<template>
  <div>
    <h2 class="col-lg-12 text-center mb-3">Adicionar ferramenta</h2>
      <FormTool @submit-requested="submitRequested"></FormTool>
  </div>
</template>
 
<script>
import { mapState, mapActions } from 'vuex'
import FormTool from '../forms/FormTool.vue'

  export default {
  components: { FormTool },
    methods: {
      ...mapActions('tools', ['addTool']),
      submitRequested (inputTool) {
        this.addTool(inputTool);
      },
    }
  }
</script> 
 
<style scoped>
</style> 